// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICensusReportDto } from './ICensusReportDto';
import {
    ICensusReportDtoFromJSON,
    ICensusReportDtoFromJSONTyped,
    ICensusReportDtoToJSON,
    ICensusReportDtoToJSONTyped,
} from './ICensusReportDto';

/**
 * 
 * @export
 * @interface ICensusRecordDto
 */
export interface ICensusRecordDto {
    /**
     * 
     * @type {number}
     * @memberof ICensusRecordDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICensusRecordDto
     */
    request_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICensusRecordDto
     */
    status?: ICensusRecordDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof ICensusRecordDto
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICensusRecordDto
     */
    raw_record?: string;
    /**
     * 
     * @type {ICensusReportDto}
     * @memberof ICensusRecordDto
     */
    report?: ICensusReportDto;
}

/**
* @export
* @enum {string}
*/
export enum ICensusRecordDtoStatusEnum {
    RECEIVED = 'RECEIVED',
    PROCESSING = 'PROCESSING',
    PROCESSED = 'PROCESSED'
}


/**
 * Check if a given object implements the ICensusRecordDto interface.
 */
export function instanceOfICensusRecordDto(value: object): value is ICensusRecordDto {
    return true;
}

export function ICensusRecordDtoFromJSON(json: any): ICensusRecordDto {
    return ICensusRecordDtoFromJSONTyped(json, false);
}

export function ICensusRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICensusRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'request_id': json['requestId'] == null ? undefined : json['requestId'],
        'status': json['status'] == null ? undefined : json['status'],
        'created_at': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'raw_record': json['rawRecord'] == null ? undefined : json['rawRecord'],
        'report': json['report'] == null ? undefined : ICensusReportDtoFromJSON(json['report']),
    };
}

export function ICensusRecordDtoToJSON(json: any): ICensusRecordDto {
    return ICensusRecordDtoToJSONTyped(json, false);
}

export function ICensusRecordDtoToJSONTyped(value?: ICensusRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'requestId': value['request_id'],
        'status': value['status'],
        'createdAt': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'rawRecord': value['raw_record'],
        'report': ICensusReportDtoToJSON(value['report']),
    };
}

